// extracted by mini-css-extract-plugin
export default {"dl":"TxDetails_dl__IR7Aa"};